import { render } from "./UserView.vue?vue&type=template&id=3fbe196b&scoped=true"
import script from "./UserView.vue?vue&type=script&lang=js"
export * from "./UserView.vue?vue&type=script&lang=js"

import "./UserView.vue?vue&type=style&index=0&id=3fbe196b&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fbe196b"]])

export default __exports__